import React from "react";
import { Paper, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import clsx from "classnames";
import { Formik } from 'formik';
import Form from '../Forms/Form';
import { useStyles, } from "../../hooks";
import styles from "./styles";

const TokenExpiration = ({errorToken, requestObtenerDetalle}) => {
    const classes = useStyles(styles);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("xs"));
    const PaperProps = {
      elevation: !matches ? 0 : 1,
      square: !matches
    }; 

    const values = {
        recaptcha: ''
      }

return (
        <Paper
         {...PaperProps}
            className={clsx(classes.root, {
              [classes.productsPage]: true,
              [classes.marginContainer]: true,
            })}
            style={{ backgroundColor: '' }}
          >
             { errorToken && 
             <>
              <Typography className={classes.inputSpacing}>
              <b>Falta poco para que seas parte del servicio.</b> A continuación te pediremos los datos de los
              beneficiarios que tendrán el servicio de Emergencias & Urgencias
              </Typography>
              <Formik
                initialValues={values}
                onSubmit={(values) => requestObtenerDetalle(values)}
              >
                {
                  () => (
                    <Form
                      GridContainerProps={{
                        spacing: 1,
                        justify: 'center'
                      }}
                      SubmitButtonProps={{
                        id: `btn-submit-authenticity`,
                        content: "Continuar",
                        color: "primary",
                        fullWidth: true
                      }}
                      forceEnabledSubmit={true}
                      recaptcha
                    >
                    </Form>)}
              </Formik></>}
           </Paper>

)}
export default TokenExpiration;